// extracted by mini-css-extract-plugin
export var menuIcon = "_q0-0";
export var menuIconInline = "_q0-1";